const t = {
  name: "BankOutUp",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.9999 0L16.4141 4.41421L14.9999 5.82843L12.9999 3.8284V7H10.9999V3.82846L8.99991 5.82843L7.58569 4.41421L11.9999 0Z" fill="currentColor"/>
<path d="M9.69849 9H14.3015L21 13.4433V16H18.99V22H21V24H3V22H5V16H3V13.4433L9.69849 9ZM14.99 16V22H16.99V16H14.99ZM11 16V22H12.99V16H11ZM7 16V22H9V16H7ZM10.3015 11L5.7789 14H18.2211L13.6985 11H10.3015Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as BankOutUp
};
